import { atom } from 'jotai/vanilla';
import { atomWithStorage } from 'jotai/vanilla/utils';

/**
 * Game statistics for a single game
 */
export interface GameStats {
  gamesPlayed: number;
  highScore: number;
  totalScore: number;
  achievements: string[];
  lastPlayed: number;
}

/**
 * All game statistics (keyed by game name)
 */
export type AllGameStats = Record<string, GameStats>;

/**
 * Game statistics atom with localStorage persistence
 * Key: spillesammen:stats
 */
export const gameStatsAtom = atomWithStorage<AllGameStats>('spillesammen:stats', {});

/**
 * Create a derived atom for a specific game's stats
 */
export const createGameStatsAtom = (gameKey: string) =>
  atom(
    (get) => {
      const stats = get(gameStatsAtom);
      return (
        stats[gameKey] || {
          gamesPlayed: 0,
          highScore: 0,
          totalScore: 0,
          achievements: [],
          lastPlayed: 0,
        }
      );
    },
    (get, set, update: Partial<GameStats>) => {
      const allStats = get(gameStatsAtom);
      const currentStats = allStats[gameKey] || {
        gamesPlayed: 0,
        highScore: 0,
        totalScore: 0,
        achievements: [],
        lastPlayed: 0,
      };

      set(gameStatsAtom, {
        ...allStats,
        [gameKey]: {
          ...currentStats,
          ...update,
        },
      });
    }
  );
